import { render, staticRenderFns } from "./_channel.vue?vue&type=template&id=40b7e4ca&"
import script from "./_channel.vue?vue&type=script&lang=js&"
export * from "./_channel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FreeHero: require('/opt/render/project/src/channels2022/src/components/free/FreeHero.vue').default,FreePartnerCurations: require('/opt/render/project/src/channels2022/src/components/free/FreePartnerCurations.vue').default,FreeCurationsButtons: require('/opt/render/project/src/channels2022/src/components/free/FreeCurationsButtons.vue').default,FreeProducts: require('/opt/render/project/src/channels2022/src/components/free/FreeProducts.vue').default,FreeExplore: require('/opt/render/project/src/channels2022/src/components/free/FreeExplore.vue').default,HomeLicensing: require('/opt/render/project/src/channels2022/src/components/home-page/HomeLicensing.vue').default,HomeFaqs: require('/opt/render/project/src/channels2022/src/components/home-page/HomeFaqs.vue').default})
